exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Palette of colours used to distinguish repeated elements */\n.description {\n  padding: 1em 0 0 32px;\n  position: relative;\n  color: #333;\n  overflow: hidden;\n}\n.description a {\n  color: #178ae0;\n  text-decoration: underline;\n}\n.description .icon {\n  font-size: 40px;\n  color: #178ae0;\n  position: absolute;\n  display: block;\n  left: -8px;\n  top: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/description/description.component.less
// module id = ../../../../../src/app/shared/description/description.component.less
// module chunks = 2